export const ENDPOINT = "https://api.nous-sommes.fr/api/";
